/**
 * インダクションの状態。
 */
export const enum InductionStatus {
  // 停止
  STOP = 0,
  // 開始
  START = 1,
  // 一時停止
  PAUSE = 2
}
